import { IFiltroDiarioClasse } from "@deltasge/marauders-map";

export enum ActionTypes {
  SET = "@modelo-diario-padrao/SET",
}

export type IModeloDiarioPadrao = Pick<
  IFiltroDiarioClasse,
  "recuperacao" | "preencherDias" | "mostrarObservacoes" | "modelo" | "lado"
>;
